export default [
  {
    path: '/log',
    redirect: '/log',
    name: 'generalLog',
    component: () => import('@/views/NestedRoute.vue'),
    children: [
      {
        path: '',
        name: 'generalLogIndex',
        component: () => import('@/views/general/log/Index.vue'),
        meta: {
          action: 'Lihat',
          resource: 'general-log',
          pageTitle: 'Log',
          breadcrumb: [
            {
              text: 'Log',
              active: true,
            },
          ],
        },
      },
    ],
  },
]
